
const SERVER_HOST = "https://cloudcalls.easipath.com/backend-pmis-woodchipping/api"
const SERVER_HOST_SERVICING = "https://cloudcalls.easipath.com/backend-pmis/api"
export {
    SERVER_HOST,
    SERVER_HOST_SERVICING
}